<template>
	<button
		type="button"
		class="p-1 shrink-0"
		@click="toggleItalic"
		:title="$t('Italic')"
		tabindex="-1"
		:class="{
			active: isActive,
			'bg-indigo-200 rounded-md': isActive,
		}"
	>
		<ItalicIcon class="w-5 h-5" />
	</button>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { ItalicIcon } from "@heroicons/vue/24/outline";

export default defineComponent({
	name: "ItalicButton",
	components: { ItalicIcon },
	props: {
		editor: { type: Object as PropType<any>, required: false },
	},
	computed: {
		isActive(): boolean {
			return !!(this.editor as any)?.isActive?.("italic");
		},
	},
	methods: {
		toggleItalic() {
			(this.editor as any)?.chain?.().focus().toggleItalic().run();
		},
	},
});
</script>
